<!-- multi-checkbox-search-v2.component.html -->
<mat-form-field>
    <mat-select #selectList [(ngModel)]="selectedValue" #select="ngModel" (openedChange)="openedChange($event)" [placeholder]="placeHolder">
      <mat-select-trigger>
        {{ selectedValue? selectedValue.name : '' }}
      </mat-select-trigger>
      <div class="select-container">
        <mat-optgroup>
          <mat-form-field style="width:100%;">
            <input #search autocomplete="off" placeholder="search" aria-label="search" matInput [(ngModel)]="searchText" (input)="filterOptions()">
            <button *ngIf="search.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch($event)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </mat-optgroup>
        <mat-optgroup *ngIf="filteredOptions?.length == 0">
          <div>No results found!</div>
        </mat-optgroup>                  
          <mat-option (onSelectionChange)="onSelectionChange($event)" *ngFor="let option of filteredOptions" [value]="option">
            {{ option.name }}
          </mat-option>        
      </div>
    </mat-select>
  </mat-form-field>
  